import { render, staticRenderFns } from "./StrippingOrderCard.vue?vue&type=template&id=3b8852bf&"
import script from "./StrippingOrderCard.vue?vue&type=script&lang=js&"
export * from "./StrippingOrderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports